export default class ProjetoColaborador {

  constructor(
    IdProjeto = null,
    IdColaborador = null,
    Colaborador = ''
  ) {
    this.IdProjeto = IdProjeto;
    this.IdColaborador = IdColaborador;
    this.Colaborador = Colaborador;
  }
  
}